import { UsuarioOnline } from './UsuarioOnline.entity';
import { Length, ValidateNested } from 'class-validator';

export class Contacto {
    @ValidateNested()
    UsuarioOnline: UsuarioOnline;
    ContratoEnUso: string;
    @Length(1, 50)
    Asunto: string;
    @Length(1, 300)
    Cuerpo: string;
    gRecaptchaResponse: string;
}